<template>
  <div>
    <v-autocomplete
      :value="account"
      :items="filterAccounts"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "AccountSelect",
  props: {
    value: {
      default: false
    },
    label: {
      default: "Account"
    },
    clearable: {
      default: false
    }
  },
  mixins: [Themeable, commonMixin]
})
export default class AccountSelect extends (Vue, Themeable) {
  account = null;
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.account = null;
    this.$emit("input", null);
  }

  get filterAccounts() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const accounts = corpService.accounts;

    if (filterby == "") {
      return accounts;
    } else {
      const fc = accounts.filter(function(c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(value) {
    this.filter = "";
    if (value) {
      this.$emit("input", value.code);
      return;
    }
    if (!value) {
      this.$emit("input", null);
    }
  }

  async init() {
    this.filter = "";
    await corpService.populateAccounts();
    const accounts = corpService.accounts;
    for (let i = 0; i < accounts.length; i++) {
      if (accounts[i].code === this.value) {
        this.account = accounts[i];
        break;
      }
    }
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val.code != null && this.account != null) {
      if (this.account != null && this.account.code != undefined) {
        if (val.code === this.account.code) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.account = null;
    }
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
